export const messages = {
    nb: {
      Header1: `Du er pålogget KF portalen`,
      Paragraph1: `Velkommen til Kreditorforeningens portal.`,
    }
  } 